import React, { FC, useCallback, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import sokort_icon from 'shared/assets/src-assets/png/sokort_icon.png';
import { GetArchivedSites, MigrateFromArchive } from 'shared/state/ducks/site/operations';
import { localized } from 'shared/state/i18n/i18n';
import { WebAppState } from 'web/state/store.web';
import { showAlert, ShowConfirmAlert } from 'web/view/components/skiold-alert/skiold-alert';
import SkioldTableGrid from 'web/view/components/skiold-components/skiold-table/skiold-table-grid/skiold-table-grid';
import { SkioldIconSpinner } from 'web/view/components/utils/skiold-icon-spinner';
interface PropsFromParent {}

export const SiteArchiveOverview: FC<PropsFromParent> = React.memo(() => {
	const dispatch = useDispatch();
	const [selectedSite, setSelectedSiteId] = React.useState<string>();

	// get redux data
	const archivedSites = useSelector((state: WebAppState) => state.site.archivedSites);
	const isLoading = useSelector((state: WebAppState) => state.site.isLoading);
	//initialize the component
	useEffect(() => {
		dispatch(GetArchivedSites());
	}, [dispatch]);

	const tableData = useMemo(() => {
		return archivedSites.map(site => {
			return {
				name: site.siteName,
				id: site.id,
			};
		});
	}, [archivedSites]);

	const archiveButton = useCallback(
		(siteRow: any) => {
			const onPress = async () => {
				if (!(await ShowConfirmAlert(localized('AreYouSureYouWantToMigrateSiteFromArchive')))) {
					return;
				}
				setSelectedSiteId(siteRow.id);
				dispatch(MigrateFromArchive(siteRow.id, showAlert));
			};
			console.log(selectedSite === siteRow.id && isLoading, isLoading, selectedSite, siteRow.id);
			return (
				<SkioldIconSpinner
					title={''}
					icon={sokort_icon}
					onPress={onPress}
					showSpinnerControlled={selectedSite === siteRow.id && isLoading}
					clipSize={30}
					width={30}
					height={30}
				/>
			);
		},
		[isLoading, selectedSite],
	);

	const columns = useMemo(() => {
		return [
			{
				name: 'name',
				title: localized('SiteName'),
			},
			{
				name: 'archive',
				title: localized('Archive'),
				getCellValue: archiveButton,
			},
		];
	}, [isLoading, selectedSite]);

	const columnExtensions = useMemo(() => {
		return [
			{ columnName: 'name', width: 300 },
			{ columnName: 'archive', width: 80 },
		];
	}, []);

	return (
		<SkioldTableGrid
			data={tableData}
			columns={columns}
			ColumnExtensions={columnExtensions}
			tableKey="sites-archived-overview"
		/>
	);
});
